/**
 * classy-meganav.js — Premium Interactions
 * - Dynamic tab switching for Sidenav mega menu.
 * - Handles details tag toggle events.
 * - lightweight and performant, no scroll locks or backdrop filters.
 */
(function () {
  'use strict';

  // Active tab toggle function (Scoped to block container for zero DOM search bloat)
  function activateTab(blockId, tabIndex) {
    var container = document.querySelector('.classy-mega-panel[data-meganav-id="' + blockId + '"]');
    var scope = container || document;

    var tabs = scope.querySelectorAll('[data-mega-tab-for="' + blockId + '"]');
    var panels = scope.querySelectorAll('[data-mega-panel-for="' + blockId + '"]');

    tabs.forEach(function (tab) {
      tab.classList.remove('classy-mega-sidebar__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });
    panels.forEach(function (panel) {
      panel.classList.remove('classy-mega-panel__content--active');
    });

    var activeTab = scope.querySelector(
      '[data-mega-tab-for="' + blockId + '"][data-mega-tab="' + tabIndex + '"]'
    );
    var activePanel = scope.querySelector(
      '[data-mega-panel-for="' + blockId + '"][data-mega-panel="' + tabIndex + '"]'
    );

    if (activeTab) {
      activeTab.classList.add('classy-mega-sidebar__tab--active');
      activeTab.setAttribute('aria-selected', 'true');
    }
    if (activePanel) {
      activePanel.classList.add('classy-mega-panel__content--active');
    }
  }

  // Throttled diagonal hover physics — active only when mouse enters a mega menu
  var mouseHistory = [];
  var pendingMouseMove = false;
  var isHoveringMega = false;

  document.addEventListener('mouseenter', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('classy-mega-panel')) {
      isHoveringMega = true;
    }
  }, true);

  document.addEventListener('mouseleave', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('classy-mega-panel')) {
      isHoveringMega = false;
      mouseHistory = [];
    }
  }, true);

  document.addEventListener('mousemove', function (e) {
    if (!isHoveringMega || pendingMouseMove) return;
    pendingMouseMove = true;
    requestAnimationFrame(function () {
      mouseHistory.push({ x: e.clientX, y: e.clientY });
      if (mouseHistory.length > 4) mouseHistory.shift();
      pendingMouseMove = false;
    });
  }, { passive: true });

  function isMovingTowardsPanel() {
    if (mouseHistory.length < 2) return false;
    var current = mouseHistory[mouseHistory.length - 1];
    var prev = mouseHistory[mouseHistory.length - 2];
    // If moving right (X coordinate increasing), we are transitioning from sidebar to content
    return current.x > prev.x;
  }

  // Mobile L2 Slide Panels
  function openL2(handle) {
    var p = document.querySelector('[data-classy-l2="' + handle + '"]');
    if (p) {
      p.classList.add('classy-mob-l2--open');
      // Scroll lock body on L2 panel open
      document.documentElement.style.overflow = 'hidden';
    }
  }

  function closeL2(handle) {
    var p = document.querySelector('[data-classy-l2="' + handle + '"]');
    if (p) {
      p.classList.remove('classy-mob-l2--open');
      
      // Release scroll lock only if no other L2 panels are open
      var anyOpen = document.querySelectorAll('.classy-mob-l2--open').length > 0;
      if (!anyOpen) {
        document.documentElement.style.overflow = '';
      }
    }
  }

  // Bind mouseenter (hover) events to tabs
  function initMegaTabs() {
    var tabs = document.querySelectorAll('[data-mega-tab]');
    tabs.forEach(function (tab) {
      var blockId = tab.getAttribute('data-mega-tab-for');
      var tabIndex = tab.getAttribute('data-mega-tab');
      var switchTimer = null;

      // Trigger switch on hover (with diagonal safety delay)
      tab.addEventListener('mouseenter', function () {
        if (isMovingTowardsPanel()) {
          clearTimeout(switchTimer);
          switchTimer = setTimeout(function () {
            activateTab(blockId, tabIndex);
          }, 150); // 150ms safety buffer
        } else {
          clearTimeout(switchTimer);
          activateTab(blockId, tabIndex);
        }
      });

      tab.addEventListener('mouseleave', function () {
        clearTimeout(switchTimer);
      });

      // Trigger switch on focus (keyboard support)
      tab.addEventListener('focus', function () {
        clearTimeout(switchTimer);
        activateTab(blockId, tabIndex);
      });
    });

    // Automatically activate the first tab whenever a details tag containing a meganav opens
    var detailsElements = document.querySelectorAll('.navmenu-depth-1 > .navmenu-item > details');
    detailsElements.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          var panelElement = details.querySelector('.classy-mega-panel[data-meganav-id]');
          if (panelElement) {
            var blockId = panelElement.getAttribute('data-meganav-id');
            // Default to first tab
            activateTab(blockId, '1');
          }
        }
      });
    });

    // Bind L2 slide panel open/close buttons for mobile
    var openButtons = document.querySelectorAll('[data-classy-l2-open]');
    openButtons.forEach(function (btn) {
      var handle = btn.getAttribute('data-classy-l2-open');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openL2(handle);
      });
    });

    var backButtons = document.querySelectorAll('[data-classy-l2-back]');
    backButtons.forEach(function (btn) {
      var handle = btn.getAttribute('data-classy-l2-back');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeL2(handle);
      });
    });

    // Bind Mobile Department Switcher Tabs (FOR MEN | FOR WOMEN | ALL)
    var mobDeptTabs = document.querySelectorAll('[data-mob-dept-tab]');
    mobDeptTabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var targetDept = tab.getAttribute('data-mob-dept-tab');

        // Toggle active tab buttons
        document.querySelectorAll('[data-mob-dept-tab]').forEach(function (t) {
          t.classList.remove('classy-mob-dept-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('classy-mob-dept-tab--active');
        tab.setAttribute('aria-selected', 'true');

        // Toggle active department panels
        document.querySelectorAll('[data-mob-dept-panel]').forEach(function (panel) {
          if (panel.getAttribute('data-mob-dept-panel') === targetDept) {
            panel.classList.add('classy-mob-dept-panel--active');
          } else {
            panel.classList.remove('classy-mob-dept-panel--active');
          }
        });
      });
    });

    // Auto-release scroll lock if mobile menu drawer closed entirely
    var closeButtons = document.querySelectorAll('[data-mobile-nav-close]');
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.documentElement.style.overflow = '';
        // Close all L2 panels
        document.querySelectorAll('.classy-mob-l2--open').forEach(function (p) {
          p.classList.remove('classy-mob-l2--open');
        });
      });
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaTabs);
  } else {
    initMegaTabs();
  }
})();

